/** Worst case API latency is assumed to be 10 sec */
import {PICK_STATUS_IN_GRID_CACHE_KEY, ROUTE_DATA_CACHE_KEY} from "./LocalStorageKeys";
import {getStationCode} from "../network/NetworkUtil";
import {isArrayEquals} from "./Util";
import {CACHE_TTL} from "./Constants";

/**
 * Saves data in local storage and set expiry time.
 */
export function setDataWithExpiry(key, value, lastUpdated) {
    const currTime = (lastUpdated === undefined)? new Date().getTime() : lastUpdated
    const record = {
        data: value,
        lastUpdated: currTime,
        expiry: currTime + CACHE_TTL
    }
    try {
        localStorage.setItem(key, JSON.stringify(record));
    } catch (e) {
    }
}

/**
 * Resets the cache for the specified key.
 * @param key
 */
export function clearCache(key) {
    try {
        localStorage.removeItem(key)
    } catch (e) {
    }
}

/**
 * Retrieves data from local storage if not expired, null otherwise.
 */
export function getDataWithExpiry(key) {
    const response = {cachedData: null, lastUpdated: null}
    try {
        const storedJson = localStorage.getItem(key) || null;
        if (!storedJson) {
            return response
        }
        const record = JSON.parse(storedJson)
        const now = new Date()

        // compare the expiry time of the item with the current time
        if (now.getTime() > record.expiry) {
            // cache is expired
            localStorage.removeItem(key)
            return response
        }
        response.cachedData = record.data
        response.lastUpdated = record.lastUpdated
        return response;
    } catch (e) {
        return response;
    }
}

/**
 * If cache is present for key, this method return number of milliseconds pending until expiry.
 * Otherwise returns 0.
 */
export function getRemainingTTL(key) {
    try {
        const storedJson = localStorage.getItem(key) || null;
        if (!storedJson) {
            return 0;
        }
        const record = JSON.parse(storedJson)
        const now = new Date()

        // compare the expiry time of the item with the current time
        if (now.getTime() < record.expiry) {
            return record.expiry - now.getTime();
        }
    } catch (e) {
    }
    return 0;
}

/**
 * Checks whether the route cache is valid or not based on the expiry time
 */
export function isRouteCacheValid(xptNodes) {
    const {cachedData} = getDataWithExpiry(ROUTE_DATA_CACHE_KEY);
    const stationCode = getStationCode();
    return cachedData && isArrayEquals(xptNodes, cachedData.xptNodes) && stationCode === cachedData.stationCode;
}

/**
 * Checks whether the pick status in grid info is valid or not based on the expiry time
 */
export function isPickStatusInGridCacheValid(xptNodes) {
    const {cachedData} = getDataWithExpiry(PICK_STATUS_IN_GRID_CACHE_KEY);
    const stationCode = getStationCode();
    return cachedData && isArrayEquals(xptNodes, cachedData.xptNodes) && stationCode === cachedData.stationCode;
}


// WEBPACK FOOTER //
// ./src/components/util/CacheManager.js